import styled from 'styled-components';
import { TransparentButton } from '../transparent-button/TransparentButton';
import TableCell from '../table/TableCell';
// Tabs.tsx
export const TabsWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  align-items: center;
  border-radius: 5rem;
  height: 5rem;
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
`;
export const ActiveTabUnderline = styled.div `
  position: absolute;
  left: ${({ activeTabIndex, length }) => `calc(${(100 / length) * activeTabIndex}% + 0.5rem)`};
  right: ${({ activeTabIndex, length }) => `calc(100% - ${(100 / length) * (activeTabIndex + 1)}% + 0.5rem)`};

  height: 4rem;
  transition: all 0.3s ease;
  border-radius: 5rem;
  background-color: ${({ theme }) => theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;
export const CustomTab = styled(TransparentButton) `
  flex: 1;
  padding: 0.5rem;
  opacity: ${({ disabled, isActive }) => (disabled && !isActive ? 0.3 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
export const TabTitle = styled(TableCell) `
  z-index: ${({ theme }) => theme.zIndex.low};
  transition: color 0.3s ease;
`;
export const Icon = styled.img `
  z-index: ${({ theme }) => theme.zIndex.highest};
  width: 4rem;
  height: 4rem;
  display: block;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  margin-right: 1.6rem;
`;
//# sourceMappingURL=styles.js.map